document.addEventListener('DOMContentLoaded', function() {
  const accordions = document.querySelectorAll('.accordion-button');

  accordions.forEach(function(accordion) {
    accordion.addEventListener('click', function() {
      // Toggle active state
      accordion.classList.toggle('active');
      const content = accordion.nextElementSibling;
      
      // Toggle visibility of content
      if (content.style.display === 'block') {
        content.style.display = 'none';
      } else {
        content.style.display = 'block';
      }
    });
  });
});